export default {
    apiBaseUrl: 'https://api.medau-therapie.de/api',
    imageBaseUrl: 'https://api.medau-therapie.de/',
    apiKey: '88657f65948ebd4cbf2fff1b651bcf5ad2cdb2d0d9f03631857eab6fc5751974aa283e49232a471782e50dd201c10667cc6501773a1e2233295982e37ff4cf7a4cd830795470d0ad48e9adcab7cfdc2c2141675c5e784db4dc0600d593fa92b78e13732d49eefafd03a82ae4d5dcc4002cd1e89c4f65264e6cccb33629279973',
}